import { useTheme } from "@mui/material";
import { createSxStyles } from "@common/createSxStyles";

export const useLinkedEntityCollapseListStyles = () => {
    const theme = useTheme();
    return createSxStyles({
        collapse: {
            marginBottom: 2,
        },
        collapseHeaderText: {
            color: theme.palette.primary.dark,
            fontWeight: theme.typography.fontWeightBold,
        },
        selector: {
            width: "50%",
            paddingBottom: 2,
        },
        // Matches the details box under a related asset on an asset.
        detailsBox: {
            width: "50%",
            backgroundColor: theme.palette.grey[100],
            paddingX: 3,
            paddingY: 2,
        },
        // The line height of the value it stands in for, so the box keeps its height when the value arrives.
        detailsValueSkeleton: {
            width: 120,
            height: 21,
        },
        detailsRow: {
            display: "flex",
            alignItems: "center",
            gap: 1,
        },
        addButton: {
            marginTop: theme.spacing(3),
            display: "flex",
            justifyContent: "center",
        },
        errorText: {
            fontSize: theme.typography.pxToRem(12),
            color: theme.palette.error.main,
            textAlign: "center",
            marginTop: theme.spacing(2),
        },
    });
};
